<template>
  <div class="main mainT2">
    <div class="testT-section testT2 v2">
      <div class="example-img">
        <img
          src="../../assets/imageTests/posture_souplesse_epaule.png"
          alt="image test 3"
          class="img-test3"
        />
      </div>
      <div class="bloc2">
        <div class="explication1 explication2">
          <p>Toucher ou attraper vos mains derrière le dos.</p>
          <p>
            Essayer des deux côtés, puis faire le test avec l'épaule la plus
            souple.
          </p>
          <p>Quand vous avez terminé sélectionner la bonne réponse :</p>
        </div>
        <div class="response-portable response-responsive">
          <ul class="test_response-portable">
            <li
              v-for="tab in info"
              :key="tab.title"
              :class="[result === tab.position ? 'active' : '']"
              :id="tab.position"
              v-on:click.prevent="send(tab.position)"
            >
              <button
                :id="tab.position"
                name="tab"
                :value="tab.position"
                :class="[{ selected: selected === tab.position }]"
                @click.prevent="selected = tab.position"
              >
                {{ tab.title }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="testT-section-portable">
      <div class="example-img-portable img3">
        <img
          src="../../assets/imageTests/posture_souplesse_epaule.png"
          alt="image test 3"
          class="img-test3-portable"
        />
      </div>
      <div class="bloc2-portable">
        <div class="explication1 explication1-portable explication2.portable">
          <p>Toucher ou attraper vos mains derrière le dos.</p>
          <p>
            Essayer des deux côtés, puis faire le test avec l'épaule la plus
            souple.
          </p>
          <p>Quand vous avez terminé sélectionner la bonne réponse :</p>
        </div>
      </div>
    </div>
    <div class="response3 portable portableP">
      <div class="response-portable">
        <ul class="test_response-portable">
          <li
            v-for="tab in info"
            :key="tab.title"
            :class="[result === tab.position ? 'active' : '']"
            :id="tab.position"
            v-on:click.prevent="send(tab.position)"
          >
            <button
              :id="tab.position"
              name="tab"
              :value="tab.position"
              :class="[{ selected: selected === tab.position }]"
              @click.prevent="selected = tab.position"
            >
              {{ tab.title }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Test_3",
  data() {
    return {
      info: [
        { title: "Les mains se touchent paume contre paume", position: 5 },
        { title: "Les mains se chevauchent", position: 4 },
        { title: "Les mains se touchent", position: 3 },
        { title: "Les mains sont écarté de moins de 5 cm", position: 2 },
        { title: "Les mains sont écartées de plus de 5 cm", position: 1 }
      ],
      activetab: 3,
      result: "",
      selected: null
    };
  },
  methods: {
    send(data) {
      this.result = data;
      localStorage.vive = data;
      this.$emit("choice3");
    }
  }
};
</script>

<style>
.img-test3-portable {
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Test/Test_3.vue